import React from 'react';
import sc from 'styled-components';
import {
	Layout,
	Dialog,
	Divider,
	Text,
	IconButton,
	Button,
	UnifonTheme,
} from '@phonectas/unifon-ui-kit';

interface StyledToolbarNewProps extends React.HTMLAttributes<HTMLDivElement> {
	$vPadding?: number;
	$hPadding?: number;
	theme: UnifonTheme;
}

export const StyledToolbarNew = sc(Layout)<StyledToolbarNewProps>`
	margin: ${({theme}) => theme.spacing(4, 0, 3)};
	padding: ${({theme, $vPadding = 0, $hPadding = 0}) => theme.spacing($vPadding, $hPadding)};
	height: ${({theme}) => theme.spacing(7.5)}px;
	min-height: ${({theme}) => theme.spacing(7.5)}px;
	align-items: center;
	position: relative;
`;

export const StyledSmallDialog = sc(Dialog)`
	width: 600px;
`;

export const StyledDivider = sc(Divider)`
	margin: 10px 0;
`;

export const StyledBigDialog = sc(Dialog)`
	width: 960px;
	max-width: 80vw;
	max-height: 90vh;
`;

export const StyledInfoText = sc(Text)`
	justify-content: center;
	align-items: center;
`;

export const StyledIconButton = sc(IconButton)<{$width?: number; $height?: number}>`
	height: ${({$width}) => $width || 24}px;
	min-Height: ${({$width}) => $width || 24}px;
	width: ${({$height}) => $height || 22}px;
	min-Width: ${({$height}) => $height || 22}px;
`;

export const StyledTrustpilotButton = sc(Button)`
	padding: 5px 5px 5px 0;
	max-height: 21px;
	border: none;
	gap: 2px;
`;

